import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { Mutex } from "async-mutex";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const baseUrl = process.env.REACT_APP_BASE_URL;
const mutex = new Mutex();

const baseQuery = fetchBaseQuery({
  baseUrl: `${baseUrl}`,
  prepareHeaders: (headers) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
    } catch (error) {
      console.error("Error parsing token:", error);
    }
    return headers;
  },
});

const CustomFetchBase = async (args, api, extraOptions) => {
  await mutex.waitForUnlock();
  let result = await baseQuery(args, api, extraOptions);

  if (result.error) {
    const status = result.error.status;
    const message = result.error.data?.message || "An error occurred";

    if (status === 401) {
      toast.error("Session expired. Please login again.");
      localStorage.clear();
      window.location.href = "/adminlogin"; // Or /login depending on routing
    } else if (status === 403) {
      toast.error("Access Denied: " + message);
    } else if (status >= 500) {
      toast.error("Server Error: Please try again later.");
    } else {
      toast.error(message);
    }
  }
  return result;
};

export default CustomFetchBase;
